import React from 'react';
import { makeRESTApiRequest } from '../../../helpers/api';
import { ENDPOINTS } from '../../../helpers/constants';
import { useEffect, useState } from 'react';
export const useGetUnderwriterCertifications = () => {
  const [underwriterCertificationList, setUnderWriterCertification] = useState([]);
  useEffect(() => {
    const fetchUnderWriter = async () => {
      try {
        const { response, error } = await makeRESTApiRequest({
          endpoint: ENDPOINTS.APP_CHOICES_LIST_PUBLIC,
          method: 'POST'
        });

        const list = response?.find(item => item.key === 'Underwriter Certification')?.values;
        setUnderWriterCertification(list || []);
      } catch (error) {}
    };
    fetchUnderWriter();
  }, []);

  return underwriterCertificationList;
};
